import React from 'react';
import PropTypes from 'prop-types';
import Select from '../Select';
import STATES from '../../../constants/states';
import { Input } from 'reactstrap';
import styles from './styles.scss';

class StateDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.onSelect = this.onSelect.bind(this);
    this.onInput = this.onInput.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.country !== this.props.country) {
      this.props.onChange('');
    }
  }

  onSelect(value) {
    this.props.onChange(value);
  }

  onInput(event) {
    this.props.onChange(event.target.value);
  }

  render() {
    const {
      value,
      country,
      onChange
    } = this.props;
    return (
      <Choose>
        <When condition={STATES[country]}>
          <Select className={`${styles.state}`}
            value={value}
            onChange={this.onSelect}
            options={STATES[country]}
          />
        </When>
      <Otherwise>
        <Input className={`${styles.state}`}
          value={value || ''}
          onChange={this.onInput}
        />
      </Otherwise>
    </Choose>
    );
  }
}

StateDropdown.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  country: PropTypes.string
}

export default StateDropdown;


// WEBPACK FOOTER //
// src/components/shared/StateDropdown/index.jsx